import { Button, Container, Flex, Heading, Text, useBreakpointValue } from '@chakra-ui/react';
import { useResources } from 'datx-jsonapi-react';
import { useTranslation } from 'react-i18next';

import { LectureSearchCard } from '@/components/ui/shared/lecture/LectureSearchCard/LectureSearchCard';
import { SearchGroup } from '@/enums';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { queryLecturesWithFilters } from '@/queries/thin-lectures';

interface ILectureURLSearchParams {
  query?: string;
  eventId?: string;
  searchGroup?: SearchGroup;
}

export const LectureSearchSection = () => {
  const { t } = useTranslation();
  const isLarge = useBreakpointValue({ base: false, '2xl': true });
  const { query, eventId, change } = useQueryParams<ILectureURLSearchParams>({
    query: StringParam,
    eventId: StringParam,
    searchGroup: StringParam,
  });

  const filters = {
    event_id: eventId,
    // searchable_attribute: SearchGroup.SPEAKERS,
    query: query || '',
  };

  const { data = [], meta } = useResources(queryLecturesWithFilters(isLarge ? 5 : 4, 1, filters, 'algolia_order'));

  function handleShowAllClick() {
    change({ query, eventId, searchGroup: SearchGroup.LECTURE }, { shallow: true, method: 'push' });
  }

  const noResults = meta?.totalCount === 0;

  return (
    <Flex flexDir="column" p={6} borderColor="gray.200" borderBottomWidth="1px" pb={6}>
      <Flex w="full" justifyContent="space-between" mb={4}>
        <Heading size="sm">Lectures</Heading>
        {!noResults && (
          <Button variant="link" onClick={handleShowAllClick} color="gray.800" size="md">
            {t('schedule.search.showAllNumber', { totalCount: meta?.totalCount || 0 })}
          </Button>
        )}
      </Flex>
      <Container px={0} maxW="container.2xl">
        {noResults && <Text>{t('schedule.search.noLectures')}</Text>}
        <Flex justifyContent={{ base: 'center', lg: 'flex-start' }} flexWrap="wrap" gap={6}>
          {data.map((lecture) => (
            <LectureSearchCard key={lecture.id} eventId={eventId} lecture={lecture} />
          ))}
        </Flex>
      </Container>
    </Flex>
  );
};
